import { Component } from '@angular/core';

@Component({
  selector: 'app-profile-loader',
  template: `
    <div
      class="u-padding-40-0 bg-color-white mat-elevation-z1 u-marginBottom-24"
    >
      <div
        [ngStyle]="{ 'max-width': '1000px', width: '95vw' }"
        class="u-margin-center"
      >
        <div fxLayout="row" fxLayoutGap="8px">
          <nz-skeleton-element
            nzType="avatar"
            [nzActive]="true"
            [nzSize]="100"
          ></nz-skeleton-element>
          <ng-container
            *ngTemplateOutlet="paragraphLoaderSkelton"
          ></ng-container>
        </div>
      </div>
    </div>
    <div
      [ngStyle]="{ 'max-width': '1000px', width: '95vw' }"
      class="u-margin-center"
      fxLayout.gt-sm="row"
    >
      <div
        fxFlex.gt-sm="360px"
        class="bg-color-white u-padding-24 mat-elevation-z1 u-marginBottom-24"
      >
        <ng-container *ngTemplateOutlet="paragraphLoaderSkelton"></ng-container>
      </div>
      <div
        fxFlex.gt-sm="calc(100% - 360px)"
        [ngClass.gt-sm]="'u-paddingLeft-24'"
      >
        <div class="bg-color-white u-padding-24 mat-elevation-z1">
          <ng-container
            *ngTemplateOutlet="paragraphLoaderSkelton"
          ></ng-container>
        </div>
      </div>
    </div>
    <ng-template #paragraphLoaderSkelton>
      <div fxLayout="column" fxLayoutGap="8px">
        <nz-skeleton-element
          nzType="input"
          [nzActive]="true"
          style="width:300px"
        ></nz-skeleton-element>
        <nz-skeleton-element
          nzType="input"
          [nzActive]="true"
          style="width:200px"
        ></nz-skeleton-element>
        <nz-skeleton-element
          nzType="input"
          [nzActive]="true"
          style="width:200px"
        ></nz-skeleton-element>
      </div>
    </ng-template>
  `,
})
export class ProfileLoaderComponent {}
